import React, { useState } from 'react';
import { formatDate } from '../../utils/helper';

function getETAText(deliveryDate, revisedEta, dataLocale) {
  const expectedTS = new Date(revisedEta || deliveryDate).setHours(0, 0, 0, 0);
  const currentTS = new Date().setHours(0, 0, 0, 0);
  const timeLeft = (expectedTS - currentTS) / (24 * 60 * 60 * 1000);
  const { ARRIVING, RUNNING_LATE, WAS_EXPECTED, NOW } = dataLocale;
  let etaText;
  if (timeLeft < 0) {
    etaText = (
      <>
        <span className="late-text">{RUNNING_LATE}, </span>
        <span>
          {WAS_EXPECTED} {formatDate(deliveryDate, 'EEE D MMM')}
        </span>
      </>
    );
  } else if (revisedEta) etaText = `${NOW} ${ARRIVING} ${formatDate(revisedEta, 'EEE, D MMM')}`;
  else {
    etaText = `${ARRIVING} ${formatDate(deliveryDate, 'EEE, D MMM')}`;
  }
  return etaText;
}

function ExpectedDelivery(props) {
  const { deliveryDate, revisedEta, dataLocale } = props;
  const [etaText] = useState(getETAText(deliveryDate, revisedEta, dataLocale));
  return (
    <span className="text-capitalize" data-testid="etaText">
      {etaText}
    </span>
  );
}

export default ExpectedDelivery;
